import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import { Button, Checkbox, Table } from "antd";
import BaseCard from "../../components/card/BaseCard";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import { $api, type components } from "../../helper";
import { contactMock, tokenMock } from "../../helper/mock";
import { useNotify } from "../../helper/notify";

export default function PrintManagement() {
  const notify = useNotify();
  const { setDashboardName } = useStore(useDashboardName);
  const { data, isLoading, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/print/",
  );
  const [value, setValue] = useState<string[]>([]);
  const { mutate, isPending } = $api.useMutation("put", "/site-api/v1/print/");
  useEffect(() => {
    setDashboardName("مدیریت چاپ");
  }, []);

  useEffect(() => {
    if (!isLoading) {
      const a = data?.data.filter((e) => e.print_in_factor);
      const b = a?.map((e) => e.u_id);
      setValue(b ?? []);
    }
  }, [isLoading]);

  const columns: TableProps<components["schemas"]["SitePrintItem"]>["columns"] =
    [
      {
        title: "#",
        dataIndex: "key",
        key: "key",
        render: (_, record, index) => <span>{index + 1}</span>,
      },
      {
        title: "عنوان تنظیمات",
        dataIndex: "title",
        key: "title",
        render: (_, record) => (
          <span>
            {contactMock.find((e) => Number(e.value) === record.title)?.label}
          </span>
        ),
      },
      {
        title: "مقدار",
        dataIndex: "value",
        key: "value",
      },
      {
        title: "عملیات",
        key: "action",
        render: (_, record) => {
          return (
            <div className="flex">
              <Checkbox
                checked={value?.includes(record.u_id)}
                value={record.u_id}
                onChange={(e) => {
                  if (value?.includes(e.target.value)) {
                    setValue((prev) =>
                      prev?.filter((c) => c !== e.target.value),
                    );
                  } else {
                    setValue([...value, e.target.value]);
                  }
                }}
              />
            </div>
          );
        },
      },
    ];

  return (
    <div className="flex flex-col gap-6">
      <div>
        <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
          <div className="w-full flex justify-end items-center">
            <Button
              onClick={() => {
                mutate(
                  {
                    body: {
                      print_u_ids: value,
                    },
                    headers: {
                      Authorization: tokenMock,
                      lang: "fa",
                    },
                  },
                  {
                    onSuccess: (data) => {
                      notify.success(data.message);
                      refetch();
                    },
                  },
                );
              }}
              loading={isPending}
              type="primary"
            >
              بروزرسانی تنظیمات
            </Button>
          </div>
          <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
            <Table<components["schemas"]["SitePrintItem"]>
              loading={isLoading}
              className="col-span-1!"
              scroll={{ x: "max-content" }}
              columns={columns}
              dataSource={data?.data}
            />
          </BaseTable>
        </BaseCard>
      </div>
    </div>
  );
}
